module.exports = __webpack_public_path__ + "static/media/decticus_verrucivorus.f91a1042.jpg";